/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Featuressubtitle1Inputs */

const he_extension_featuressubtitle1 = /** @type {(inputs: Extension_Featuressubtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`כל הכלים שאתם צריכים לקבלת החלטות רכישה מושכלות`)
};

const en_extension_featuressubtitle1 = /** @type {(inputs: Extension_Featuressubtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All the tools you need to make informed purchasing decisions`)
};

/**
* | output |
* | --- |
* | "All the tools you need to make informed purchasing decisions" |
*
* @param {Extension_Featuressubtitle1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_featuressubtitle1 = /** @type {((inputs?: Extension_Featuressubtitle1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Featuressubtitle1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_featuressubtitle1(inputs)
	return en_extension_featuressubtitle1(inputs)
});
export { extension_featuressubtitle1 as "extension_featuresSubtitle" }